import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL } from '@helpers';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

import DashboardOverviewHeader from './components/DashboardOverviewHeader';
import DashboardOverviewTopBlock from './components/DashboardOverviewTopBlock';
import DashboardOverviewBottomBlock from './components/DashboardOverviewBottomBlock';
import { useDashboardOverviewViewModel } from './hooks/useDashboardOverviewViewModel';

interface DashboardOverviewProps extends WithColor {}

const DashboardOverview: FC<DashboardOverviewProps> = ({ C }) => {
  const {
    scope,
    resultType,
    overall: dashboardOverallData,
    onSelectScope,
    onSelectResultType,
    worst,
    worstLoading,
    worstError,
    best,
    bestLoading,
    bestError,
    onShowAllWorst,
    onShowAllBest,
    onShowAllActual,
    onRowPress,
  } = useDashboardOverviewViewModel();

  return (
    <View
      testID={TEST_IDS.dashboardOverview.screen}
      style={{
        paddingTop: scale(72),
        paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL),
        flex: 1,
        backgroundColor: C('Background/Light/Modal'),
      }}
    >
      <DashboardOverviewHeader />
      <DashboardOverviewTopBlock
        dashboardOverallData={dashboardOverallData}
        scope={scope}
        onSelectScope={onSelectScope}
        resultType={resultType}
        onSelectResultType={onSelectResultType}
        containerStyle={{ marginTop: scale(12) }}
      />
      <DashboardOverviewBottomBlock
        scope={scope}
        resultType={resultType}
        worst={worst}
        best={best}
        worstLoading={worstLoading}
        bestLoading={bestLoading}
        worstError={worstError}
        bestError={bestError}
        onShowAllWorst={onShowAllWorst}
        onShowAllBest={onShowAllBest}
        onShowAllActual={onShowAllActual}
        onRowPress={onRowPress}
        containerStyle={{ marginTop: scale(25) }}
      />
    </View>
  );
};

export default ColorWrapper(DashboardOverview);
